import styled from "styled-components";

const StyledLabel = styled.label`
  cursor: default;
`;

export default StyledLabel;
